export const ClosedStatuses = ["Without Intervention", "Rejected", "Resolved"];
